// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__11U5d","label":"styles_label__fqu5Z"};